export default __webpack_public_path__ + "static/background-35d7764c9e74117b1751853624426f89.png";